import React from 'react'
import { useTranslation } from 'react-i18next'

import { BudgetChartBudgets } from 'src/types'

import Budget from '..'
import { StyledContainer, StyledTitle } from './styles'

interface Props {
  bars: BudgetChartBudgets[]
}

function BudgetReceipt({ bars }: Props) {
  const { t } = useTranslation()

  return (
    <>
      <StyledTitle>{t('common.budget.title')}</StyledTitle>
      <StyledContainer>
        <div>
          <Budget bars={bars} />
        </div>
      </StyledContainer>
    </>
  )
}

export default BudgetReceipt
